import UserHeader from "@/models/user-header";
import { AuthService } from "@/services/auth.service";
import * as Msal from "@azure/msal-browser";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ActionContext, Module } from "vuex";
import { StoreData } from "@/store";

export interface AuthData {
  user: { user: UserHeader } | null;
}

export default {
  namespaced: true,
  state: (): AuthData => ({
    user: null,
  }),
  actions: {
    login: async (): Promise<Msal.AuthenticationResult | void> => {
      return await AuthService.login();
    },
    handleRedirectCallback:
      async (): Promise<void | Msal.AuthenticationResult | null> => {
        return await AuthService.handleRedirectCallback();
      },
    acquireTokenGraph: async (): Promise<Msal.AuthenticationResult | void> => {
      return await AuthService.acquireTokenGraph();
    },
    acquireTokenClient: async (): Promise<Msal.AuthenticationResult | void> => {
      return await AuthService.acquireTokenClient();
    },
    getUser: (
      context: ActionContext<AuthData, StoreData>
    ): Observable<{ user: UserHeader }> => {
      return AuthService.getUser().pipe(
        tap((user: { user: UserHeader }) => {
          context.commit("setUser", user);
        })
      );
    },
    logout: async (
      context: ActionContext<AuthData, StoreData>
    ): Promise<void> => {
      await AuthService.logout();
      context.commit("setUser", null);
      // this.setUser(null);
      window.axios.defaults.headers.common["Authorization"] = ``;
    },
  },
  mutations: {
    setUser: (state: AuthData, user: { user: UserHeader }): void => {
      state.user = user;
    },
  },
  getters: {
    getAccount: (): Msal.AccountInfo | null => {
      return AuthService.getAccount();
    },
    getAccountUsername: (): string | null => {
      return AuthService.getAccount()?.username ?? null;
    },
    getAccounts: (): Msal.AccountInfo[] => {
      return AuthService.getAccounts();
    },
    getMsal: (): Msal.PublicClientApplication => {
      return AuthService.getMsal();
    },
    isCommitee: (state: AuthData): boolean => {
      return state.user?.user.roleName === "Commitee";
    },
    isParticipant: (state: AuthData): boolean => {
      return state.user?.user.roleName === "Participant";
    },
    isJury: (state: AuthData): boolean => {
      return state.user?.user.isJury == true;
    },
    // role-based jury (UserRole.Jury = 2) — distinct from the IsJury team flag
    isJuryRole: (state: AuthData): boolean => {
      return state.user?.user.roleName === "Jury";
    },
    canActAsJury: (state: AuthData): boolean => {
      return state.user?.user.canActAsJury == true;
    },
    isFormerJury: (state: AuthData): boolean => {
      return state.user?.user.isFormerJury == true;
    },
  },
} as Module<AuthData, StoreData>;
